const questions = [
  // 1 Слайд \\
  {
    questionDesc: "Tanggal berapa yang terangkum dalam arsitektur Monas?",
    answerOptions: [
      {
        answerText: "1 Juni 1945",
        answerResult:
          "Pada proporsi Monas, terangkum tanggal Proklamasi Kemerdekaan Republik Indonesia: 17.08.1945. Tinggi cawan penyangga—17 meter, lebar landasan—8 meter, sementara lebar cawan itu sendiri—45 meter.",
        result: false,
      },
      {
        answerText: "17 Agustus 1945",
        answerResult:
          "Pada proporsi Monas, terangkum tanggal Proklamasi Kemerdekaan Republik Indonesia: 17.08.1945. Tinggi cawan penyangga—17 meter, lebar landasan—8 meter, sementara lebar cawan itu sendiri—45 meter.",
        result: true,
      },
      {
        answerText: "18 Agustus 1945",
        answerResult:
          "Pada proporsi Monas, terangkum tanggal Proklamasi Kemerdekaan Republik Indonesia: 17.08.1945. Tinggi cawan penyangga—17 meter, lebar landasan—8 meter, sementara lebar cawan itu sendiri—45 meter.",
        result: false,
      },
      {
        answerText: "28 Oktober 1928",
        answerResult:
          "Pada proporsi Monas, terangkum tanggal Proklamasi Kemerdekaan Republik Indonesia: 17.08.1945. Tinggi cawan penyangga—17 meter, lebar landasan—8 meter, sementara lebar cawan itu sendiri—45 meter.",
        result: false,
      },
    ],
    image: "images/1.jpg",
  },

  // 2 слайд \\
  {
    questionDesc: "Di mana teks Proklamasi Kemerdekaan Indonesia dirumuskan?",
    answerOptions: [
      {
        answerText: "Di rumah Laksamana Maeda",
        answerResult:
          "Dokumen resmi dirumuskan di rumah Laksamana Maeda. Versi akhir diketik oleh Sayuti Melik, sementara teks tersebut dibacakan kemudian di kediaman Soekarno.",
        result: true,
      },
      {
        answerText: "Di rumah Soekarno, di Jalan Pegangsaan Timur No. 56",
        answerResult:
          "Dokumen resmi dirumuskan di rumah Laksamana Maeda. Versi akhir diketik oleh Sayuti Melik, sementara teks tersebut dibacakan kemudian di kediaman Soekarno.",
        result: false,
      },
      {
        answerText: "Di Gedung Pancasila",
        answerResult:
          "Dokumen resmi dirumuskan di rumah Laksamana Maeda. Versi akhir diketik oleh Sayuti Melik, sementara teks tersebut dibacakan kemudian di kediaman Soekarno.",
        result: false,
      },
      {
        answerText: "Di Rengasdengklok",
        answerResult:
          "Dokumen resmi dirumuskan di rumah Laksamana Maeda. Versi akhir diketik oleh Sayuti Melik, sementara teks tersebut dibacakan kemudian di kediaman Soekarno.",
        result: false,
      },
    ],
    image: "images/2.jpg",
  },

  // 3 слайд \\
  {
    questionDesc:
      "Pada awalnya, di mana teks proklamasi rencananya akan dibacakan?",
    answerOptions: [
      {
        answerText: "Di Lapangan Ikada",
        answerResult:
          "Para tokoh penyusun teks proklamasi bermaksud untuk mengumpulkan massa di Lapangan Ikada yang luas (saat ini adalah Lapangan Merdeka di sekeliling Monas). Namun, akibat risiko terjadinya bentrokan dengan para prajurit Jepang, upacara tersebut akhirnya dipindahkan ke kediaman Soekarno.",
        result: true,
      },
      {
        answerText: "Di Lapangan Kota Ubud",
        answerResult:
          "Para tokoh penyusun teks proklamasi bermaksud untuk mengumpulkan massa di Lapangan Ikada yang luas (saat ini adalah Lapangan Merdeka di sekeliling Monas). Namun, akibat risiko terjadinya bentrokan dengan para prajurit Jepang, upacara tersebut akhirnya dipindahkan ke kediaman Soekarno.",
        result: false,
      },
      {
        answerText: "Di Gedung PPKI",
        answerResult:
          "Para tokoh penyusun teks proklamasi bermaksud untuk mengumpulkan massa di Lapangan Ikada yang luas (saat ini adalah Lapangan Merdeka di sekeliling Monas). Namun, akibat risiko terjadinya bentrokan dengan para prajurit Jepang, upacara tersebut akhirnya dipindahkan ke kediaman Soekarno.",
        result: false,
      },
      {
        answerText: "Di Lapangan Merdeka",
        answerResult:
          "Para tokoh penyusun teks proklamasi bermaksud untuk mengumpulkan massa di Lapangan Ikada yang luas (saat ini adalah Lapangan Merdeka di sekeliling Monas). Namun, akibat risiko terjadinya bentrokan dengan para prajurit Jepang, upacara tersebut akhirnya dipindahkan ke kediaman Soekarno.",
        result: false,
      },
    ],
    image: "images/3.jpg",
  },

  // 4 слайд \\
  {
    questionDesc:
      "Mengapa pada teks Proklamasi Kemerdekaan, tahun 1945 ditulis sebagai 05?",
    answerOptions: [
      {
        answerText: "Ini merupakan singkatan dari tahun 1945",
        answerResult:
          "Pada teks Proklamasi tertulis: “Djakarta, hari 17, boelan 8, tahoen 05”. 05 merupakan singkatan dari tahun 2605 menurut penanggalan Kaisar Jepang yang saat itu secara resmi berlaku di Indonesia.",
        result: false,
      },
      {
        answerText: "Ini adalah kode rahasia pergerakan pemuda",
        answerResult:
          "Pada teks Proklamasi tertulis: “Djakarta, hari 17, boelan 8, tahoen 05”. 05 merupakan singkatan dari tahun 2605 menurut penanggalan Kaisar Jepang yang saat itu secara resmi berlaku di Indonesia.",
        result: false,
      },
      {
        answerText: "Ini adalah kesalahan pada saat pengetikan",
        answerResult:
          "Pada teks Proklamasi tertulis: “Djakarta, hari 17, boelan 8, tahoen 05”. 05 merupakan singkatan dari tahun 2605 menurut penanggalan Kaisar Jepang yang saat itu secara resmi berlaku di Indonesia.",
        result: false,
      },
      {
        answerText: "Ini merupakan tahun menurut kalender Jepang",
        answerResult:
          "Pada teks Proklamasi tertulis: “Djakarta, hari 17, boelan 8, tahoen 05”. 05 merupakan singkatan dari tahun 2605 menurut penanggalan Kaisar Jepang yang saat itu secara resmi berlaku di Indonesia.",
        result: true,
      },
    ],
    image: "images/4.jpg",
  },

  // 5 слайд \\
  {
    questionDesc:
      "Apa yang terjadi dengan bendera merah putih pertama Indonesia?",
    answerOptions: [
      {
        answerText: "Bendera tersebut dikembalikan kepada keluarga Soekarno",
        answerResult:
          "Bendera legendaris Sang Saka Merah Putih yang dijahit oleh istri Soekarno, dalam waktu lama digunakan di banyak parade, tetapi seiring waktu kainnya mulai menjadi rapuh. Saat ini, bendera yang dipasang di tiang bendera adalah bendera duplikat, sementara yang asli disimpan di Istana Merdeka.",
        result: false,
      },
      {
        answerText: "Bendera tersebut diserahkan ke Istana Merdeka",
        answerResult:
          "Bendera legendaris Sang Saka Merah Putih yang dijahit oleh istri Soekarno, dalam waktu lama digunakan di banyak parade, tetapi seiring waktu kainnya mulai menjadi rapuh. Saat ini, bendera yang dipasang di tiang bendera adalah bendera duplikat, sementara yang asli disimpan di Istana Merdeka.",
        result: true,
      },
      {
        answerText: "Bendera diserahkan ke Museum di Belanda",
        answerResult:
          "Bendera legendaris Sang Saka Merah Putih yang dijahit oleh istri Soekarno, dalam waktu lama digunakan di banyak parade, tetapi seiring waktu kainnya mulai menjadi rapuh. Saat ini, bendera yang dipasang di tiang bendera adalah bendera duplikat, sementara yang asli disimpan di Istana Merdeka.",
        result: false,
      },
      {
        answerText: "Bendera tersebut hilang pada saat pemindahan arsip",
        answerResult:
          "Bendera legendaris Sang Saka Merah Putih yang dijahit oleh istri Soekarno, dalam waktu lama digunakan di banyak parade, tetapi seiring waktu kainnya mulai menjadi rapuh. Saat ini, bendera yang dipasang di tiang bendera adalah bendera duplikat, sementara yang asli disimpan di Istana Merdeka.",
        result: false,
      },
    ],
    image: "images/5.jpg",
  },

  // 6 слайд \\
  {
    questionDesc: "Mengapa Rengasdengklok penting dalam sejarah Indonesia?",
    answerOptions: [
      {
        answerText:
          "Di sana untuk pertama kalinya Sang Saka Merah Putih dikibarkan",
        answerResult:
          "Di Rengasdengklok para pemuda pergerakan meyakinkan Soekarno dan Hatta untuk tidak lagi menunda deklarasi kemerdekaan. Peristiwa ini dikenal sebagai Peristiwa Rengasdengklok, dan menjadi salah satu peristiwa kunci sebelum Proklamasi Kemerdekaan 17 Agustus 1945",
        result: false,
      },
      {
        answerText: "Di sana Teks Proklamasi diketik",
        answerResult:
          "Di Rengasdengklok para pemuda pergerakan meyakinkan Soekarno dan Hatta untuk tidak lagi menunda deklarasi kemerdekaan. Peristiwa ini dikenal sebagai Peristiwa Rengasdengklok, dan menjadi salah satu peristiwa kunci sebelum Proklamasi Kemerdekaan 17 Agustus 1945",
        result: false,
      },
      {
        answerText:
          "Di sanalah Soekarno dan Hatta dibujuk untuk tidak lagi menunda-nunda deklarasi kemerdekaan",
        answerResult:
          "Di Rengasdengklok para pemuda pergerakan meyakinkan Soekarno dan Hatta untuk tidak lagi menunda deklarasi kemerdekaan. Peristiwa ini dikenal sebagai Peristiwa Rengasdengklok, dan menjadi salah satu peristiwa kunci sebelum Proklamasi Kemerdekaan 17 Agustus 1945",
        result: true,
      },
      {
        answerText: "Di sanalah Belanda mengakui kemerdekaan Indonesia",
        answerResult:
          "Di Rengasdengklok para pemuda pergerakan meyakinkan Soekarno dan Hatta untuk tidak lagi menunda deklarasi kemerdekaan. Peristiwa ini dikenal sebagai Peristiwa Rengasdengklok, dan menjadi salah satu peristiwa kunci sebelum Proklamasi Kemerdekaan 17 Agustus 1945",
        result: false,
      },
    ],
    image: "images/6.jpg",
  },
];

export default questions;
